// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"gantt_ganttVerticalContainer__C34A-","horizontalContainer":"gantt_horizontalContainer__tYhbQ","wrapper":"gantt_wrapper__+7fcE"};